import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import { onCssLengthChange, onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import BackgroundPicker from '../../../widgets/BackgroundPicker';

class General extends Component {
    render() {
        const isDisabled = this.props.themeAccess || this.props.isDisabled;

        return (
            <div className="General">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-lg-1 col-xs-12 col-sm-6">
                        Color
                        <BackgroundPicker
                            background={this.props.background}
                            preset={this.props.themeColors.primary.colors}
                            isDisabled={isDisabled}
                            onChange={property =>
                                this.props.onThemePropChange('gallery.overlay.background')({
                                    target: {
                                        value: property
                                    }
                                })
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

General.propTypes = {
    tagNameName: PropTypes.string
};

General.contextTypes = {
    store: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        themeColors: state.app.data.theme.colors
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onThemePropChange: onThemePropChange(dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(General);



// WEBPACK FOOTER //
// ./src/components/pages/theme/carousel/General.js